import "./LogoutNotif.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CircleAlert, X } from "lucide-react";
import { logout } from "../../features/authSlice.js";
import ApiService from "../Api_services";

const LogoutNotif = ({ onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    // Reset the login notif flag
    localStorage.removeItem("hasClosedLoginNotif");
    const session_key =
      localStorage.getItem("sso_session_key") ||
      localStorage.getItem("access_token") ||
      "";
    try {
      if (session_key) {
        await ApiService.logout(session_key);
      }
    } catch (err) {
      // swallow API errors, still proceed to clear client state
      console.error("Logout API error", err);
    } finally {
      // clear client state
      localStorage.removeItem("access_token");
      localStorage.removeItem("sso_session_key");
      localStorage.removeItem("customer_id");
      localStorage.removeItem("salesman_id");
      localStorage.removeItem("company_name");
      localStorage.removeItem("real_company_name");
      localStorage.removeItem("sub_role");
      dispatch(logout());
      navigate("/");
    }
  };

  const stopPropagation = (e) => e.stopPropagation();

  return (
    <div className="logoutnotif_v2" onClick={onClose}>
      <div className="logoutnotif-content_v2" onClick={stopPropagation}>
        <div className="logoutnotif-title-container_v2">
          <div className="logoutnotif-title_v2">
            <div className="logoutnotif-icon_v2">
              <CircleAlert />
            </div>
            <strong>Confirm Logout?</strong>
          </div>

          <button className="lnclose-button_v2" onClick={onClose}>
            <X />
          </button>
        </div>

        <div className="logoutnotif-main_v2">
          Are you sure you want to logout?
        </div>

        <div className="logoutnotif-sub_v2">
          <div className="no_v2">
            <button onClick={onClose}>Cancel</button>
          </div>
          <div className="yes_v2">
            <button onClick={handleLogout}>Logout</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutNotif;
